import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, LottiePlayer, Typography } from '@dxb-web-ui-framework/design-system';
import { LocalLibrary as LocalLibraryIcon } from '@dxb-web-ui-framework/design-system/dist/icons';
import { GenericObject } from '@dxb-web-ui-framework/common/types';

const ResolvedFinalStep: FC<GenericObject> = () => {
  const [switchContent, setSwitchContent] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setSwitchContent(true);
    }, 3000);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <>
      <Box
        data-testid={'client-side-wizard-finalStep'}
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
        height={'40vh'}>
        <Box display={'flex'} flexDirection={'column'} justifyContent='center' alignItems={'center'} mb={2}>
          {!switchContent ? (
            <>
              <Box mb={2}>
                <LottiePlayer height={64} icon='tick' loop play width={64} />
              </Box>
              <Typography variant={'h3'} style={{ color: 'green' }}>
                {t('successErrorPage.SuccessTitle.Text')}
              </Typography>
              <Box>
                <Typography variant={'body2'} color={'textPrimary'}>
                  {t('successErrorPage.SubmissionMessage.Text')}
                </Typography>
              </Box>
            </>
          ) : (
            <Typography variant={'body2'} color={'textPrimary'}>
              {t('successErrorPage.ApplicationProcessMessage.Text')}
            </Typography>
          )}
        </Box>
      </Box>
      <Box justifySelf={'flex-end'} alignSelf={'center'}>
        <Button
          component={'a'}
          href={'https://www.ecommbanx.com/'}
          color='primary'
          endIcon={<LocalLibraryIcon />}
          size='large'
          variant='text'>
          {t('successErrorPage.LearnMoreLink.Text')}
        </Button>
      </Box>
    </>
  );
};

export { ResolvedFinalStep };

export default ResolvedFinalStep;
